/**
 * @generated SignedSource<<0aa4c7d10067c2d600b977c8960d54b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectModalQueryRenderer_searchResult$data = {
  readonly project: {
    readonly tradePhotos: ReadonlyArray<{
      readonly height: number | null;
      readonly name: string | null;
      readonly path: string | null;
      readonly serviceId: string | null;
      readonly url: string | null;
      readonly width: number | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ProjectModalQueryRenderer_searchResult";
};
export type ProjectModalQueryRenderer_searchResult$key = {
  readonly " $data"?: ProjectModalQueryRenderer_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectModalQueryRenderer_searchResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectModalQueryRenderer_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "designProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradePhoto",
          "kind": "LinkedField",
          "name": "tradePhotos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeInteriorProjectQueryOutput",
  "abstractKey": null
};

(node as any).hash = "cb56805c8e708e6b7b2d15f64e1a986c";

export default node;
